/**
 * The intro card — the two strings the kid meets before the first question.
 *
 * These are DEFINITION fields, not row fields: the row's title is the catalogue handle a tutor
 * picks from ("Baseline Math - Grade 4"), while `definition.title` is what the story calls itself
 * ("The Astronaut's Dilemma"). Creating a template seeds them identically; they diverge after.
 *
 * Nothing is mutated here — both setters are one-line store calls (B9).
 */
import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useAssessmentEditorStore } from './store'

interface UseIntroEditorReturn {
  refTitle: ComputedRef<string>
  refDescription: ComputedRef<string>
  setTitle: (value: string) => void
  setDescription: (value: string) => void
}

export const useIntroEditor = (): UseIntroEditorReturn => {
  const store = useAssessmentEditorStore()

  const refTitle = computed<string>(() => store.getDefinitionTitle)
  const refDescription = computed<string>(() => store.getDefinitionDescription)

  /** Required by the schema, so an emptied field stores `''` and validation asks for a title; it
   *  never deletes the key, which would be an invalid document. */
  const setTitle = (value: string): void => {
    store.setDefinitionTitle(value)
  }

  /** Optional, so an emptied field deletes the key and the player falls back to its own line. */
  const setDescription = (value: string): void => {
    store.setDefinitionDescription(value)
  }

  return { refTitle, refDescription, setTitle, setDescription }
}
